import React from 'react'
import styled from 'styled-components'

import Button from '../Button'
import Input, { InputProps } from '../Input'
import Value from "../Value";
import {number} from "prop-types";

interface TokenInputProps extends InputProps {
  max: number | string,
  symbol: string,
  onSelectMax?: () => void,
}

const TokenInput: React.FC<TokenInputProps> = ({
  max,
  symbol,
  onChange,
  onSelectMax,
  value,
}) => {

  return (
    <StyledTokenInput>
      <StyledMaxText> <Value value={parseFloat(max.toString())} decimals={2} padding="0 5px 0 0"/>{symbol} Available</StyledMaxText>
      <Input
        endAdornment={(
          <StyledTokenAdornmentWrapper>
            <StyledTokenSymbol>{symbol}</StyledTokenSymbol>
            {/*<StyledSpacer />*/}
            <div>
              <Button size="sm" bGColor="#0F1C3F" borderColor="#202E53" color="#7688B7" text="Max" onClick={onSelectMax} />
            </div>
          </StyledTokenAdornmentWrapper>
        )}
        onChange={onChange}
        placeholder="0"
        value={value}
      />
    </StyledTokenInput>
  )
};

/*
            <div>
              <Button size="sm" text="Max" />
            </div>
*/

const StyledTokenInput = styled.div`

`

const StyledSpacer = styled.div`
  width: ${props => props.theme.spacing[3]}px;
`

const StyledTokenAdornmentWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-width: 200px;
@media (max-width: 768px) {
  min-width: 0;
  }
`

const StyledMaxText = styled.div`
  align-items: center;
  color: rgba(79, 98, 148, 1);
  display: flex;
  font-size: 14px;
  font-weight: 700;
  height: 44px;
  justify-content: flex-end;
`

const StyledTokenSymbol = styled.span`
  color: rgba(118, 136, 183, 1);
  font-weight: 700;
  font-size: 14px;
  @media (max-width: 768px) {
  font-size: 10px;
  margin-right: 5px;
  }
`

export default TokenInput
